<template>
  <div class="error-info-footer">
    <div
      v-if="info && !errors[0]"
      class="flex flex-align-center">
      <svg
        v-if="prefixIcon && typeof prefixIcon === 'string' && prefixIcon.endsWith('.svg')"
        class="mr-1 flex-start-image"
        :data-src="prefixIcon"
        fill="currentColor"
        width="10"
        height="10" />
      <img
        v-else-if="prefixIcon && typeof prefixIcon === 'string'"
        :src="prefixIcon"
        style="width: 10px; height: 10px;"
        class="mr-1 flex-start-image"
      >
      <SBIcon
        v-else-if="!noPrefixIcon"
        class="mr-1"
        :icon="prefixIcon || SBIconList.INFO"
        :color="SBColors.greyLight"
        :size="10" />
      <span>{{ info }}</span>
    </div>
    <div
      v-if="errors[0]"
      class="error flex flex-align-center"
      :class="{ warning: warningValidators.includes(Object.keys(failedRules)[0])}">
      <SBIcon
        class="mr-1"
        :icon="warningValidators.includes(Object.keys(failedRules)[0]) ? SBIconList.INFO : SBIconList.ERROR"
        :color="warningValidators.includes(Object.keys(failedRules)[0]) ? '#DEBD30' : SBColors.redPrimary"
        :size="10" />
      <span>{{ validatorMessages && validatorMessages[Object.keys(failedRules)[0]] ? validatorMessages[Object.keys(failedRules)[0]] : errors[0] }}</span>
    </div>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'ErrorInfoFooter',
  components: {
    SBIcon,
  },
  props: {
    prefixIcon: {
      type: [String, Object],
      required: false,
      default: '',
    },
    noPrefixIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    info: {
      type: String,
      required: false,
      default: '',
    },
    errors: {
      type: Array,
      required: false,
      default: () => [],
    },
    failedRules: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    warningValidators: {
      type: Array,
      default: () => [],
    },
    validatorMessages: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
};
</script>

<style scoped lang="scss">
.error-info-footer {
  margin-top: 5px;

  * {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    text-align: left;
    color: $blackUltralight;
  }

  .error {
    * {
      color: $redPrimary !important;
    }

    &.warning * {
      color: #DEBD30 !important;
    }

    // a {
    //   color: $redPrimary !important;
    //   text-decoration: underline !important;
    // }
  }
}
</style>
